export type DurationObject = {
  id: number;
  label: string;
};

const durationList: DurationObject[] = [
  { id: 5, label: '5 minutes' },
  { id: 7, label: '7 minutes' },
  { id: 8, label: '8 minutes' },
  { id: 10, label: '10 minutes' },
  { id: 15, label: '15 minutes' },
  { id: 20, label: '20 minutes' },
  { id: 25, label: '25 minutes' },
  { id: 30, label: '30 minutes' },
  { id: 35, label: '35 minutes' },
  { id: 40, label: '40 minutes' },
  { id: 45, label: '45 minutes' },
  { id: 60, label: '1 hour' },
  { id: 75, label: '1:15 hours' },
  { id: 90, label: '1:30 hours' },
  { id: 120, label: '2 hours' },
  { id: 150, label: '2:30 hours' },
  { id: 180, label: '3 hours' },
];

export default durationList;
